// 字典请求路径
export var BASE_API = "/wms/commonDictionary/queryByGroupIdentification/";

// 字典
export var dicts = {
  // 单据类型
  BILL_TYPE: "".concat(BASE_API, "BILL_TYPE"),
  // 作业类型
  JOB_TYPE: "".concat(BASE_API, "JOB_TYPE"),
  // 业务类型
  MOVE_TYPE: "".concat(BASE_API, "MOVE_TYPE"),
  // A5打印机名称
  PRINTER_A5: "".concat(BASE_API, "PRINTER_A5"),
  // 10x15打印机名称
  PRINTER_10_15: "".concat(BASE_API, "PRINTER_10_15"),
  // 10x10打印机名称
  PRINTER_10_10: "".concat(BASE_API, "PRINTER_10_10"),
  // 面单规格
  PRINTER_TYPE: "".concat(BASE_API, "PRINTER_TYPE")
};

// 需要自动获取物流单号的物流公司code
// 固定位置，不可变换位置，只能往后加
export var isAutoLogisticsCodes = ["1000"];